export enum CongratsBoxActionTypes {
  API_RESPONSE_SUCCESS = "@@CongratsBox/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@CongratsBox/API_RESPONSE_ERROR",

  CREATE_CONGRATS = "@@CongratsBox/CREATE_CONGRATS",
  GET_CONGRATS = "@@CongratsBox/GET_CONGRATS",
  UPDATE_CONGRATS = "@@CongratsBox/UPDATE_CONGRATS",
  DELETE_CONGRATS = "@@CongratsBox/DELETE_CONGRATS",
}
